import React from 'react';
import { ChakraProvider } from '@chakra-ui/react'
import theme from '@/shared/theme'

import { AuthProvider } from './contexts/auth';
import { MindsProvider, LatestReleaseProvider } from './contexts/minds';
import { UsersProvider } from './contexts/users';
import { ReportsProvider } from './contexts/reports';
import { MachinesProvider } from './contexts/machines';
import { GatewaysProvider } from './contexts/gateways';


function AppProviders({ children }) {

  return (
    <AuthProvider>
      <MindsProvider>
        <UsersProvider>
          <ReportsProvider>
            <LatestReleaseProvider>
              <MachinesProvider>
                <GatewaysProvider>
                  <ChakraProvider theme={theme}>
                    {children}
                  </ChakraProvider>
                </GatewaysProvider>
              </MachinesProvider>
            </LatestReleaseProvider>
          </ReportsProvider>
        </UsersProvider>
      </MindsProvider>
    </AuthProvider>
  );
}

export default AppProviders;